// Web Push (docs/features/web-push.md): the window `notifications` (one per Mac) from a Mac's ⋯ › Notifications… —
// on or off by hand; and the automatic part (core/webpush.js): every paired Mac subscribed by itself, at start, after a
// pairing, and again when a Mac lost this device's subscription. What the subscribe page or a notification hands back
// is taken at start.
import { registerWindow } from '../../core/windows.js'
import { registerHomeItem } from '../../core/home-items.js'
import { arrive, startAuto } from '../../core/webpush.js'

registerWindow('notifications', { module: () => import('./notifications.js'), css: 'windows/notifications/notifications.css', key: (a, key) => 'notifications-' + (key || 'mac'), title: () => 'Notifications', place: ['home', 'trailing'] })
registerHomeItem({ id: 'notifications', label: 'Notifications…', symbol: 'lucide:bell', needs: 'paired', section: 'mac', order: 26 })
if (typeof location !== 'undefined' && typeof document !== 'undefined' && document.body) {
  // read before the app takes the fragment (core/transport.js): a pairing's room is the Mac to subscribe first
  const hash = new URLSearchParams(String(location.hash || '').replace(/^#/, ''))
  const paired = /^[a-f0-9]{32,64}$/.test(hash.get('room') || '') ? hash.get('room') : null
  if (/(^#|&)push(mac|sub|card|answer)=/.test(location.hash || '')) setTimeout(() => arrive(), 0)
  startAuto(paired)
}
